import { render, staticRenderFns } from "./SchoolBreadcrumb.vue?vue&type=template&id=0811202b&scoped=true&"
import script from "./SchoolBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./SchoolBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolBreadcrumb.vue?vue&type=style&index=0&id=0811202b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811202b",
  null
  
)

export default component.exports